const Page404 = () => {
  return (
    <div className="h-screen w-full flex bg-white justify-center bg-cyan-400">
      <h1 className="text-white font-bold text-5xl mt-40">404: Page not found</h1>
    </div>
  )
}

export default Page404
